import { render, staticRenderFns } from "./MaterialCreativeThirdList.vue?vue&type=template&id=2ed36d8a&scoped=true&"
import script from "./MaterialCreativeThirdList.vue?vue&type=script&lang=js&"
export * from "./MaterialCreativeThirdList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCreativeThirdList.vue?vue&type=style&index=0&id=2ed36d8a&lang=stylus&scoped=true&"
import style1 from "./MaterialCreativeThirdList.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed36d8a",
  null
  
)

export default component.exports